import React from 'react';
const EditIcon = (props) => (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "#005A5A", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { id: "Edit-solid" },
        React.createElement("path", { id: "Vector", d: "M13.8067 4.69333C14.0667 4.43333 14.0667 4 13.8067 3.75333L12.2467 2.19333C12 1.93333 11.5667 1.93333 11.3067 2.19333L10.08 3.41333L12.58 5.91333M2 11.5V14H4.5L11.8733 6.62L9.37333 4.12L2 11.5Z" }))));
export default EditIcon;
